var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 3.42188C14.8313 3.6625 14.25 3.825 13.6375 3.9C14.2625 3.525 14.7438 2.93125 14.9688 2.225C14.3844 2.57187 13.7375 2.825 13.0469 2.95937C12.4938 2.36875 11.7063 2 10.8375 2C9.16567 2 7.81255 3.35625 7.81255 5.02812C7.81255 5.26562 7.83755 5.49688 7.89067 5.71875C5.37505 5.59375 3.1438 4.3875 1.65317 2.55312C1.3938 3 1.2438 3.52187 1.2438 4.075C1.2438 5.125 1.7813 6.05313 2.5938 6.59688C2.0938 6.58438 1.62505 6.44688 1.2188 6.21875V6.25625C1.2188 7.725 2.26255 8.94688 3.64692 9.225C3.3938 9.29375 3.12505 9.33125 2.85005 9.33125C2.6563 9.33125 2.46567 9.3125 2.2813 9.275C2.66567 10.4781 3.78442 11.3531 5.10942 11.3781C4.07505 12.1906 2.7688 12.675 1.35005 12.675C1.1063 12.675 0.865674 12.6594 0.628174 12.6313C1.96255 13.5 3.55317 14 5.25942 14C10.8313 14 13.875 9.38438 13.875 5.38125C13.875 5.25 13.8719 5.11875 13.8657 4.99062C14.4563 4.5625 14.9688 4.03125 15.375 3.42188Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTw);
export default __webpack_public_path__ + "static/media/tw.1be7c40d.svg";
export { ForwardRef as ReactComponent };